import React from 'react';
import { useAppContext } from '@/context/context';
import { Dialog, Typography } from '@sm-dashboard/ui-components';

const DeleteDialog = ({
  handleDeleteEvent,
  setOpenDialog,
  openDialog,
  title = 'מחיקה',
  content = 'האם אתה בטוח שברצונך למחוק את האירוע?'
}: {
  handleDeleteEvent: () => Promise<void>;
  setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
  openDialog: boolean;
  title?: string;
  content?: string;
}) => {
  const { setSnackbar } = useAppContext();

  const handleClose = async () => {
    try {
      setOpenDialog(false);
      await handleDeleteEvent();
      setSnackbar({ open: true, message: 'האירוע נמחק בהצלחה', severity: 'success' });
    } catch (error) {
      setSnackbar({ open: true, message: 'שגיאה במחיקת האירוע', severity: 'error' });
    }
  };

  return (
    <Dialog
      open={openDialog}
      title={title}
      cancelAction={{ onClick: () => setOpenDialog(false) }}
      primaryAction={{ label: 'אישור', onClick: handleClose }}
    >
      <Typography variant="body" color="text.secondary">
        {content}
      </Typography>
    </Dialog>
  );
};

export default DeleteDialog;
